import { Box } from 'components/ui';
import { FormattedMessage } from 'react-intl';
import { ArrowDropUpIcon, ArrowDropDownIcon } from 'components/uiIcons';

const SortableHeader = ({ field, label, sortBy, onSortChange, textAlign = 'center' }) => {
  const ascValue = `${field}_asc`;
  const descValue = `${field}_desc`;
  const isAsc = sortBy === ascValue;
  const isDesc = sortBy === descValue;
  const isActive = isAsc || isDesc;

  const handleClick = () => {
    if (isAsc) {
      onSortChange(descValue);
    } else {
      onSortChange(ascValue);
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleClick();
    }
  };

  if (!onSortChange) {
    return <FormattedMessage id={label} />;
  }

  const ariaSort = isAsc ? 'ascending' : isDesc ? 'descending' : 'none';

  return (
    <Box
      role="button"
      tabIndex={0}
      aria-sort={ariaSort}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      sx={{
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: textAlign === 'left' ? 'flex-start' : 'center',
        userSelect: 'none',
        fontWeight: isActive ? 'bold' : 'normal',
        '&:hover': { opacity: 0.7 },
        '&:focus-visible': { outline: '2px solid currentColor', outlineOffset: 2 },
      }}
    >
      <FormattedMessage id={label} />
      {isActive && (isDesc ? <ArrowDropDownIcon aria-hidden="true" /> : <ArrowDropUpIcon aria-hidden="true" />)}
    </Box>
  );
};

export default SortableHeader;
